import { PropsWithChildren } from "react";
import { Box, useTheme } from "@mui/material";
import { FormBox } from "@foodpilot/foods";

type SupplierFormContentProps = PropsWithChildren;

export const SupplierFormContent = ({ children }: SupplierFormContentProps) => {
    return (
        <Box data-testid="supplier-form-content" sx={{ width: "100%" }}>
            {children}
        </Box>
    );
};

type SupplierFormCardProps = PropsWithChildren;

export const SupplierFormCard = ({ children }: SupplierFormCardProps) => {
    const theme = useTheme();

    return (
        <SupplierFormContent>
            <FormBox data-testid="supplier-form-card" sx={{ padding: 0, width: "100%" }}>
                <Box
                    sx={{
                        padding: {
                            xs: theme.spacing(3),
                            md: theme.spacing(5),
                        },
                    }}
                >
                    {children}
                </Box>
            </FormBox>
        </SupplierFormContent>
    );
};
